import { openModal } from './ModalUtils';
export class AuthOverlay {
    static initialize() {
        const loginButton = document.getElementById('auth-login-button');
        if (!loginButton)
            return;
        loginButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            AuthOverlay.renderModal('login');
        });
    }
    static renderModal(view) {
        const existing = document.getElementById(AuthOverlay.modalId);
        const contentHost = existing === null || existing === void 0 ? void 0 : existing.querySelector('.oe-modal__content');
        if (existing && contentHost) {
            const header = existing.querySelector('.oe-modal__header');
            if (header)
                header.textContent = AuthOverlay.getTitle(view);
            contentHost.innerHTML = '';
            contentHost.appendChild(AuthOverlay.buildIntro(view));
            contentHost.appendChild(AuthOverlay.buildForm(view));
            return;
        }
        openModal({
            id: AuthOverlay.modalId,
            title: AuthOverlay.getTitle(view),
            width: 620,
            keepBlocked: true,
            closeOnBackdrop: true,
            closeOnEscape: true,
            onClose: () => console.log('[AuthOverlay] Modal closed'),
        }, (container) => {
            container.appendChild(AuthOverlay.buildIntro(view));
            container.appendChild(AuthOverlay.buildForm(view));
        });
    }
    static buildIntro(view) {
        const intro = document.createElement('div');
        intro.className = 'auth-modal__intro';
        const headline = document.createElement('div');
        headline.className = 'auth-modal__headline';
        headline.innerText = view === 'login'
            ? 'Welcome back. The infinite awaits you.'
            : view === 'signup'
                ? 'Create a secure Orbscape identity.'
                : 'Reset access';
        const subtext = document.createElement('div');
        subtext.className = 'auth-modal__subtext';
        subtext.innerText = view === 'login'
            ? 'Sign in to start creating.'
            : view === 'signup'
                ? ''
                : 'Confirm where to send recovery instructions.';
        intro.appendChild(headline);
        intro.appendChild(subtext);
        return intro;
    }
    static buildForm(view) {
        const form = document.createElement('form');
        form.className = 'auth-form';
        const fields = AuthOverlay.getFields(view);
        // I need to figure out how to make the email / password fields match the styling of the username field
        fields.forEach((field) => {
            var _a;
            const row = document.createElement('div');
            row.className = 'auth-form__row';
            const label = document.createElement('label');
            label.className = 'auth-form__label';
            label.htmlFor = field.id;
            label.innerText = field.label;
            const input = document.createElement('input');
            input.id = field.id;
            input.name = field.id;
            input.type = field.type;
            input.placeholder = field.placeholder;
            // use setAttribute to provide a string value and avoid strict AutoFill typing issues
            input.setAttribute('autocomplete', (_a = field.autoComplete) !== null && _a !== void 0 ? _a : 'off');
            input.required = true;
            row.appendChild(label);
            row.appendChild(input);
            form.appendChild(row);
        });
        const actionRow = document.createElement('div');
        actionRow.className = 'auth-form__actions';
        const primary = document.createElement('button');
        primary.type = 'submit';
        primary.className = 'primary';
        primary.innerText = AuthOverlay.getCtaLabel(view);
        const linkBar = document.createElement('div');
        linkBar.className = 'auth-form__links';
        const secondaryLink = document.createElement('button');
        secondaryLink.type = 'button';
        secondaryLink.className = 'auth-form__link-button';
        secondaryLink.innerText = view === 'login' ? 'Create account' : 'Back';
        secondaryLink.addEventListener('click', () => {
            AuthOverlay.renderModal(view === 'login' ? 'signup' : 'login');
        });
        const tertiaryLink = document.createElement('button');
        tertiaryLink.type = 'button';
        tertiaryLink.className = 'auth-form__link-button';
        tertiaryLink.innerText = view === 'reset' ? 'Use password login' : 'Forgot password';
        tertiaryLink.addEventListener('click', () => {
            AuthOverlay.renderModal(view === 'reset' ? 'login' : 'reset');
        });
        linkBar.appendChild(secondaryLink);
        linkBar.appendChild(tertiaryLink);
        actionRow.appendChild(linkBar);
        actionRow.appendChild(primary);
        form.appendChild(actionRow);
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            const payload = {};
            fields.forEach((field) => {
                var _a, _b;
                const value = (_b = (_a = form.querySelector(`#${field.id}`)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                payload[field.id] = value;
            });
            console.log(`[AuthOverlay] TODO ${view} flow`, payload);
        });
        return form;
    }
    static getFields(view) {
        if (view === 'signup') {
            return [
                { id: 'username', label: 'Username', type: 'text', placeholder: 'JohnnyOrbscape67', autoComplete: 'name' },
                { id: 'email', label: 'Email', type: 'email', placeholder: 'johnnyorbscape@orbsonly.com', autoComplete: 'email' },
                { id: 'password', label: 'Create password', type: 'password', placeholder: '', autoComplete: 'new-password' },
            ];
        }
        if (view === 'reset') {
            return [
                { id: 'recoveryEmail', label: 'Email', type: 'email', placeholder: 'johnnyorbscape@orbs.com', autoComplete: 'email' },
            ];
        }
        return [
            { id: 'username', label: 'Username', type: 'text', placeholder: '', autoComplete: 'name' },
            { id: 'password', label: 'Password', type: 'password', placeholder: '', autoComplete: 'current-password' },
        ];
    }
    static getTitle(view) {
        switch (view) {
            case 'signup':
                return 'Join Orbscape';
            case 'reset':
                return 'Reset password';
            default:
                return 'Log in to Orbscape';
        }
    }
    static getCtaLabel(view) {
        switch (view) {
            case 'signup':
                return 'Create account';
            case 'reset':
                return 'Send reset link';
            default:
                return 'Log in';
        }
    }
}
AuthOverlay.modalId = 'auth-experience-modal';
